import { useNavigate } from "react-router-dom";
import { ClipboardList } from "lucide-react";
import { Panel, AddButton, ListCard, Empty } from "@/components/Bits";
import { StatusBadge } from "@/config/os";
import { useAuth } from "@/context/AuthContext";
import { useFetch, fmtDate } from "@/lib/useFetch";

export const OSCard = ({ o }) => (
  <ListCard to={`/ordens-servico/${o.os_id}`} icon={ClipboardList} testId={`os-card-${o.os_id}`}
    title={`${o.numero} · ${o.categoria_nome || o.servico_solicitado}`}
    subtitle={`${o.cliente_nome || ""} — ${o.fazenda_nome || ""}`}
    meta={`${fmtDate(o.data)}${o.horario ? ` ${o.horario}` : ""}${o.tecnico_nome ? ` · ${o.tecnico_nome}` : ""}`}
    badge={<StatusBadge status={o.status} />} />
);

export const OSHistory = ({ filter, newQuery }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { data } = useFetch("/ordens", filter);
  const isCli = user.role === "cliente";
  const canCreate = user.role === "admin" || isCli;
  return (
    <Panel title="Histórico de ordens de serviço" testId="os-history"
      action={canCreate && <AddButton small onClick={() => navigate(`/ordens-servico/${isCli ? "solicitar" : "nova"}?${new URLSearchParams(newQuery)}`)} data-testid="os-history-new">{isCli ? "Pedir atendimento" : "Nova OS"}</AddButton>}>
      {data?.length === 0 && <Empty>Nenhuma OS registrada.</Empty>}
      <div className="space-y-3">{(data || []).map((o) => <OSCard key={o.os_id} o={o} />)}</div>
    </Panel>
  );
};
